import React from 'react';
import { P, H4 } from '@tpr/core';
import { Footer } from '../../../../components/card';
import { Form, FFRadioButton, renderFields } from '@tpr/forms';
import { Content } from '../../../../components/content';
import { ArrowButton } from '../../../../../buttons/buttons';
import styles from './reason.module.scss';
import elementStyles from '@tpr/forms/lib/elements/elements.module.scss';
export var Reason = function (_a) {
    var type = _a.type, i18nRemoveReason = _a.i18nRemoveReason, onSubmit = _a.onSubmit, remove = _a.remove, dateField = _a.dateField;
    return (React.createElement(Content, { type: type, title: i18nRemoveReason.title },
        React.createElement(Form, { onSubmit: onSubmit, initialValues: {
                reason: remove && remove.reason,
                date: remove && remove.date && new Date(remove.date),
            } }, function (_a) {
            var handleSubmit = _a.handleSubmit, submitError = _a.submitError, form = _a.form;
            var reason = form.getState().values.reason;
            var showError = !!submitError && !reason;
            var leftScheme = reason === 'left_the_scheme';
            return (React.createElement("form", { onSubmit: handleSubmit, "data-testid": "remove-" + type + "-form" },
                React.createElement("div", { className: showError ? elementStyles.labelError : null },
                    React.createElement("fieldset", null,
                        React.createElement("legend", null,
                            React.createElement(H4, { fontWeight: "bold", mb: 0 }, i18nRemoveReason.subtitle)),
                        showError && (React.createElement(P, { role: "alert", cfg: { color: 'danger.2', mt: 5 }, className: elementStyles.errorMessage }, submitError)),
                        React.createElement(FFRadioButton, { name: "reason", type: "radio", testId: "leftTheScheme", label: i18nRemoveReason.fields.leftTheScheme.label, value: "left_the_scheme", cfg: { my: 4 } }),
                        leftScheme && (React.createElement("div", { className: styles.dateWrapper }, renderFields(dateField))),
                        React.createElement(FFRadioButton, { name: "reason", type: "radio", label: i18nRemoveReason.fields.neverPartOfTheScheme.label, value: "not_part_of_scheme" }))),
                React.createElement(Footer, null,
                    React.createElement(ArrowButton, { appearance: "secondary", pointsTo: "right", iconSide: "right", type: "submit", title: "Continue" }))));
        })));
};
//# sourceMappingURL=reason.js.map